import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faArrowRight, faTasks, faTachometer, faEye, faPlus, faTrashCan, faBed, faPencil, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'

import { EQUIPMENT_OPTIONS } from "../../Constants/FieldOptions";
import { getSessionTemplateDetailAPI } from "../../API/SessionTemplate";
import { getSelectedOptions } from "../../Helpers/selectHelper";
import { putSessionTemplateUpdateAPI } from "../../API/SessionTemplate";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import FormTextareaField from "../Reusable/FormTextareaField";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import FormRadioField from "../Reusable/FormRadioField";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { getSessionTemplateListAPI, deleteSessionTemplateAPI } from "../../API/SessionTemplate";
import { useRecoilState } from 'recoil';
import { topAlertMessageState, topAlertStatusState } from "../../AppState";


function SessionTemplateDetailForSleepQuestion() {
    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// URL Parameters.
    ////

    const { sid } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [selectedSleepQuestionForDeletion, setSelectedSleepQuestionForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionTemplateDetailForSleepQuestionSuccess(response){
        console.log("onSessionTemplateDetailForSleepQuestionSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailForSleepQuestionError(apiErr) {
        console.log("onSessionTemplateDetailForSleepQuestionError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailForSleepQuestionDone() {
        console.log("onSessionTemplateDetailForSleepQuestionDone: Starting...");
        setFetching(false);
    }

    function onSleepQuestionDeleteSuccess(response){
        console.log("onSleepQuestionDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Sleep question deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        // fetchList();
    }

    function onSleepQuestionDeleteError(apiErr) {
        console.log("onSleepQuestionDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onSleepQuestionDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSleepQuestionDeleteDone() {
        console.log("onSleepQuestionDeleteDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectSleepQuestionForDeletion = (e, sleepQuestion) => {
        console.log("onSelectSleepQuestionForDeletion", sleepQuestion);
        setSelectedSleepQuestionForDeletion(sleepQuestion);
    }

    const onDeselectSleepQuestionForDeletion = (e) => {
        console.log("onDeselectSleepQuestionForDeletion");
        setSelectedSleepQuestionForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick", selectedSleepQuestionForDeletion); // For debugging purposes only.

        //
        // The following code will remove the data from the JSON.
        //

        let vsIndex;
        for (let sleepQuestionIndex in sessionTemplate.sleepQuestions) {
            let vs = sessionTemplate.sleepQuestions[sleepQuestionIndex];
            if (vs.name === selectedSleepQuestionForDeletion.name) {
                vsIndex = sleepQuestionIndex;
                break;
            }
        }
        console.log("sleepQuestionIndex:", vsIndex);
        sessionTemplate.sleepQuestions.splice(vsIndex, 1);

        // Remove from state.
        setSelectedSleepQuestionForDeletion("");

        // Update the sessionTemplate.
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("SessionTemplate updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.

            setFetching(true);
            getSessionTemplateDetailAPI(
                sid,
                onSessionTemplateDetailForSleepQuestionSuccess,
                onSessionTemplateDetailForSleepQuestionError,
                onSessionTemplateDetailForSleepQuestionDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Sleep Questions)</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-templates`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link></li>
                        </ul>
                    </nav>

                    {/* Modal(s) */}
                    <nav class="">
                        <div class={`modal ${selectedSleepQuestionForDeletion ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={onDeselectSleepQuestionForDeletion}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this <strong>sleep question</strong> and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={onDeselectSleepQuestionForDeletion}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page content */}
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Template</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/session-template/${sid}/sleep-questions/add`} class="button is-small is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Sleep Question
                                </Link>
                            </div>
                        </div>

                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link to={`/session-template/${sid}`}>Detail</Link>
                                </li>
                                {(() => {
                                    // Defensive code: Only run this if we have data.
                                    if (sessionTemplate !== undefined && sessionTemplate !== null && sessionTemplate !== "") {
                                        // Show based on session type.
                                        switch (sessionTemplate.sessionType) {
                                            case "base": return (
                                                <li>
                                                    <Link to={`/session-template/${sid}/video-sections`}>Video Sections</Link>
                                                </li>
                                            );
                                            case "sleep": return (
                                                <li>
                                                    <Link class="is-active" to={`/session-template/${sid}/sleep-questions`}><strong>Sleep Questions</strong></Link>
                                                </li>
                                            );
                                            case "breath": return (
                                                <li>
                                                    <Link to={`/session-template/${sid}/breathwork-options`}>Breathing Options</Link>
                                                </li>
                                            );
                                            default: return null;
                                        };
                                    }
                                    // In case we don't have a session template.
                                    return null;
                                })()}
                            </ul>
                        </div>

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                <div class="columns">

                                    <div class="column">

                                        <div class="columns">
                                            <div class="column">
                                                <p class="subtitle"><FontAwesomeIcon className="fas" icon={faBed} />&nbsp;Sleep Questions</p>
                                            </div>

                                        </div>

                                        {sessionTemplate && sessionTemplate.sleepQuestions && sessionTemplate.sleepQuestions.length > 0
                                            ? <>
                                                {sessionTemplate.sleepQuestions.map((object, i) => <SleepQuestionRow sid={sid} obj={object} i={i} key={i} onSelectSleepQuestionForDeletion={onSelectSleepQuestionForDeletion} />)}
                                            </>
                                            : <>
                                                <div class="hero-body">
                                                  <p class="title">
                                                      <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No data
                                                  </p>
                                                  <p class="subtitle">
                                                      No data. <b><Link to={`/session-template/${sid}/sleep-questions/add`}>Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started creating your first sleep question.
                                                  </p>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        <div class="columns">
                            <div class="column is-half">
                                <Link to="/session-templates" class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/session-template/${sid}/sleep-questions/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New Sleep Question</Link>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </>
    );
}

function SleepQuestionRow(props) {
    const { sid, obj, i, onSelectSleepQuestionForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { id, title, subtitle } = obj;

    console.log(title, subtitle );
    return (
        <div class="box">
            {/*
                ##################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                ##################################################################
            */}
            <div class="is-hidden-touch" >
                <div className="columns">
                    <div className="column is-half">
                        <div class="is-pulled-left">
                            <p class="title is-5">{title}</p>
                            <p class="subtitle is-6">{subtitle}</p>
                        </div>
                    </div>
                    <div className="column is-half">
                        <div class="is-pulled-right">
                            <Link to={`/session-template/${sid}/sleep-question/${i}`} class="button is-primary"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                            {/*
                            <Link to={`/session-template/${sid}/sleep-question/${i}/edit`} class="button is-warning"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                            <button onClick={(e, ses) => onSelectSleepQuestionForDeletion(e, obj)} class="button is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                             */}
                        </div>
                    </div>
                </div>
            </div>

            {/*
                ###########################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                ###########################################################################
            */}
            <div class="is-fullwidth is-hidden-desktop mb-5">
                <strong>Title:</strong>&nbsp;{title}
                <br />
                <br />
                <strong>Subtitle:</strong>&nbsp;{subtitle}
                <br />
                <br />
                <Link to={`/session-template/${sid}/sleep-question/${i}`} class="button is-primary is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                {/*
                <Link to={`/session-template/${sid}/sleep-question/${i}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                <button onClick={(e, ses) => onSelectSleepQuestionForDeletion(e, obj)} class="button is-danger is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                */}
            </div>
        </div>

    );
}

export default SessionTemplateDetailForSleepQuestion;
